<template>
  <div class="listmain ">
    <h1 class="firTitle">颜色的设置</h1>

<p>
	<span class="ql-author-7802039 ql-size-9">颜色取值参考附录2 颜色值列表</span>
</p>
	  <highlight-code lang="javascript">
		  {
		  "header":{
			  "namespace":"Orion.Iot.Device.Control",
			  "name":"SetColor",
			  "messageId":"83a82001-3494-18ae-f4d9-691b1834f2df",
			  "payLoadVersion":1
		  },
		  "payload":{
			  "accessToken":"access token",
			  "deviceId":"abcde12345",
			  "deviceType":"light",
			  "attribute":"color",
			  "value":"Red",
			  "extensions":{
			  	"extension1":"",
			  	"extension2":""
			  }
		  }
		  }
	  </highlight-code>
	  <p>
		  <span class="ql-author-7802039 ql-size-9">正常响应：</span>
	  </p>
	  <highlight-code lang="javascript">
		  {
		  "header":{
			  "namespace":"Orion.Iot.Device.Control",
			  "name":"SetColorResponse",
			  "messageId":"83a82001-3494-18ae-f4d9-691b1834f2df",
			  "payLoadVersion":1
		  },
		  "payload":{
		 	 "deviceId":"abcde12345"
		  }
		  }
	  </highlight-code>

  </div>
</template>

<script>
export default {
  name: ""
};
</script>


<style rel="stylesheet/scss" lang="scss" scoped>
  h1,
  h2,
  h3,
  h4,
  h5 {
    padding: 0;
    margin: 0px;
    font-weight: normal;
  }

  ul,
  li {
    list-style: none;
  }

  .listmain {
    font-size: 14px;
    line-height: 26px;
    .firTitle {
      font-size: 20px;
      color: #1e4d79;
      margin-bottom: 30px;
    }
    .sedTitle {
      font-size: 16px;
      font-weight: bold;
      padding-bottom: 10px;
      border-bottom: 1px solid #f3f3f3;
      margin-bottom: 15px;
      margin-top: 50px;
      &.fir {
        margin-top: 0px;
      }
    }
    .thirdTitle {
      margin-top: 50px;
      font-weight: bold;
      line-height: 30px;
      font-size: 16px;
    }
    .codeTitle {
      font-weight: bold;
      line-height: 26px;
    }
    pre {
      margin-top: 20px;
    }
    img {
      margin: 30px 0;
      width: 100%;
    }
    table,
    table tr th,
    table tr td {
      border: 1px solid #000;
      text-align: center;
    }
    table {
      line-height: 30px;
      width: 100%;
      border-collapse: collapse;
    }
  }

  .el-submenu .el-menu-item {
    min-width: 190px;
    background: #f5f5f5;
  }

  .el-submenu {
    min-width: 190px;
    background: #f5f5f5;
  }

  img {
    margin-top: 30px;
    margin-bottom: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/tutor/smartHome/equipmentControl/Zn_sb_ys.vue